module.exports = __webpack_public_path__ + "static/media/aldi6.b96d1dbb.jpg";